/**
 * 默认展示的国家代码
 */

export default [
  {
    "des": "‫الإمارات العربية المتحدة‬",
    "code": "971",
    "nationalFlagIcon": "https://a.spikex.com/nationalflag/United-Arab-E..png",
    "isKyc": 0,
    "name": "United Arab Emirates",
    "id": 6,
    "nameEn": "United Arab Emirates",
    "shortName": "AE",
    "xtId": 6
  },
  {
    "des": "Brasil",
    "code": "55",
    "nationalFlagIcon": "https://a.spikex.com/nationalflag/Brazil.png",
    "isKyc": 0,
    "name": "Brazil",
    "id": 30,
    "nameEn": "Brazil",
    "shortName": "BR",
    "xtId": 30
  },
  {
    "des": "‫المملكة العربية السعودية‬",
    "code": "966",
    "nationalFlagIcon": "https://a.spikex.com/nationalflag/Saudi-Arabia.png",
    "isKyc": 0,
    "name": "Saudi Arabia",
    "id": 166,
    "nameEn": "Saudi Arabia",
    "shortName": "SA",
    "xtId": 166
},

  // {
  //   code: "91",
  //   des: "भारत",
  //   id: 219,
  //   name: "印度",
  //   nameEn: "India",
  //   shortName: "IN",
  //   nationalFlagIcon: "https://oss-xt.oss-cn-hongkong.aliyuncs.com/public/countrylogo/India.png",
  // },
  // {
  //   des: "China",
  //   code: "86",
  //   name: "中国",
  //   nameEn: "China",
  //   id: 1,
  //   shortName: "CN",
  //   nationalFlagIcon: "https://xt-dev-user-center.s3.ap-southeast-1.amazonaws.com/userCenter/China-1657529521636.png",
  // },
  // {
  //   des: "Singapore",
  //   code: "65",
  //   name: "新加坡",
  //   nameEn: "Singapore",
  //   id: 207,
  //   shortName: "SG",
  //   nationalFlagIcon: "https://oss-xt.oss-cn-hongkong.aliyuncs.com/public/countrylogo/Singapore.png",
  // },
  // {
  //   des: "にほん",
  //   code: "81",
  //   name: "日本",
  //   nameEn: "Japan",
  //   id: 156,
  //   shortName: "JP",
  //   nationalFlagIcon: "https://oss-xt.oss-cn-hongkong.aliyuncs.com/public/countrylogo/japan.png",
  // },
  // // {
  // //   des: "대한민국",
  // //   code: "82",
  // //   name: "韩国",
  // //   nameEn: "South Korea",
  // //   id: 81,
  // //   shortName: "KR",
  // //   nationalFlagIcon: "https://xt-prod-common-sdk.s3.ap-southeast-1.amazonaws.com/nationalflag/South-Korea.png",
  // // },
  // {
  //   des: "United States",
  //   code: "1",
  //   name: "美国",
  //   nameEn: "United States",
  //   id: 131,
  //   shortName: "US",
  //   nationalFlagIcon: "https://oss-xt.oss-cn-hongkong.aliyuncs.com/public/countrylogo/United-States.png",
  // },
  // {
  //   des: "Schweiz",
  //   code: "41",
  //   name: "瑞士",
  //   nameEn: "Schweiz",
  //   id: 158,
  //   shortName: "CH",
  //   nationalFlagIcon: "https://xt-prod-common-sdk.s3.ap-southeast-1.amazonaws.com/nationalflag/Switzerland.png",
  // },
  // {
  //   des: "Hong Kong",
  //   code: "852",
  //   name: "中国香港",
  //   nameEn: "Hong Kong",
  //   id: 206,
  //   shortName: "HK",
  //   nationalFlagIcon: "https://oss-xt.oss-cn-hongkong.aliyuncs.com/public/countrylogo/Hong-Kong.png",
  // },
  // {
  //   des: "中国澳門",
  //   code: "853",
  //   name: "中国澳门",
  //   nameEn: "Macau",
  //   id: 21,
  //   shortName: "MO",
  //   nationalFlagIcon: "https://xt-dev-user-center.s3.ap-southeast-1.amazonaws.com/userCenter/image-20220627152624041-1656325260997.png",
  // },
  // {
  //   des: "中国台灣",
  //   code: "886",
  //   name: "中国台湾",
  //   nameEn: "Taiwan",
  //   id: 184,
  //   shortName: "TW",
  //   nationalFlagIcon: "https://xt-prod-common-sdk.s3.ap-southeast-1.amazonaws.com/nationalflag/Taiwan.png",
  // },
];
